"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M41 36a3 3 0 0 1-3-3V19a3 3 0 0 1 6 0v14a3 3 0 0 1-3 3zM7 36a3 3 0 0 1-3-3V19a3 3 0 0 1 6 0v14a3 3 0 0 1-3 3zm5-20v20a2 2 0 0 0 2 2h2v7a3 3 0 0 0 6 0v-7h4v7a3 3 0 0 0 6 0v-7h2a2 2 0 0 0 2-2V16zm0-2h24a11.97 11.97 0 0 0-4.877-9.641l2.614-2.614A1 1 0 0 0 32.323.331l-2.951 2.95a11.907 11.907 0 0 0-10.745 0l-2.95-2.95a1 1 0 1 0-1.414 1.414l2.614 2.614A11.97 11.97 0 0 0 12 14zm18-4h-2V8h2zm-10 0h-2V8h2z" })
);

